export default __webpack_public_path__ + "static/media/domain.65d1445d.svg";